import { NAV_LINKS } from "../../data";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-[#2C2621] bg-[#12100E]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-6">
            <img
              src="/logo.jpg"
              alt="Ranchoddas Jivraj & Company"
              className="h-20 w-20 rounded-full object-cover ring-1 ring-[#D49A44]/40 mb-6"
            />
            <h3 className="font-serif-lux text-3xl md:text-4xl text-[#F4EFE6] leading-tight max-w-md">
              Ranchoddas Jivraj <span className="italic text-[#D49A44]">& Company</span>
            </h3>
            <p className="font-sans-lux text-sm text-[#7C756B] mt-4 tracking-[0.2em] uppercase">
              Merchants of Sandalwood & Saffron · Est. 1911
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-sans-lux text-[10px] uppercase tracking-[0.25em] text-[#7C756B] mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="font-sans-lux text-sm text-[#B0A89D] hover:text-[#D49A44] transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-sans-lux text-[10px] uppercase tracking-[0.25em] text-[#7C756B] mb-5">Trade</p>
            <ul className="space-y-3 font-sans-lux text-sm text-[#B0A89D]">
              <li>jivrajranchoddas@gmail.com</li>
              <li>Mumbai, India</li>
              <li>Worldwide Export</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[#2C2621] pt-8 flex flex-col md:flex-row justify-between gap-4">
          <p className="font-sans-lux text-xs text-[#7C756B]">
            © {new Date().getFullYear()} Ranchoddas Jivraj & Company. All rights reserved.
          </p>
          <p className="font-sans-lux text-xs text-[#7C756B] tracking-[0.2em] uppercase">
            A century of aroma, unbroken.
          </p>
        </div>
      </div>
    </footer>
  );
};
